






























import Vue from 'vue';
import SideBar from '@/components/sidebar/SideBar.vue';
import { EventType, ValidationMessages } from '@/constants';

export default Vue.extend({
  name: 'SignIn',
  components: {
    SideBar,
    Login: () => import('./components/Login.vue'),
    ResetPasswordPanel: () => import('./components/ResetPasswordPanel.vue')
  },
  data () {
    return {
      resetPassword: false,
      message: '',
      email: ''
    };
  },
  mounted () {
    const redirectUrl = this.$route.query.redirectTo
      ? this.$route.query.redirectTo.toString()
      : '';
    if (redirectUrl === 'reset') {
      this.resetPassword = true;
      this.message = ValidationMessages.resetFailed;
    }
  },
  methods: {
    toggleLoginAndReset () {
      this.resetPassword = !this.resetPassword;
    },
    signedIn () {
      this.$emit(EventType.SIGNIN);
    }
  }
});
